import LandingPageTestimonials from '@/app/components/LandingPage/LandingPageTestimonials';

import heartHealthTestimonials from '../_data/heartHealthTestimonials';

const HeartHealthTestimonials = () => {
  return (
    <LandingPageTestimonials
      data-cy="heart-health-testimonials"
      testimonials={heartHealthTestimonials}
      theme="brown"
    />
  );
};

export default HeartHealthTestimonials;
